/* eslint-disable */
import {
  VALID_RANKS,
  FIXED_DUTY_STATE,
  getRatingExamNumber,
} from '../constants/examConstants';

const getRankDisplayName = (rank) => {
  switch (rank) {
    case 'E5':
      return 'E-5';
    case 'E6':
      return 'E-6';
    default:
      return rank;
  }
};

export function getRanks() {
  return [
    {
      id: 'All',
      name: 'All',
    },
    ...VALID_RANKS.map((rank) => ({
      id: rank,
      name: getRankDisplayName(rank),
    })),
  ];
}

export function getDutyStates() {
  return [
    {
      id: 'All',
      name: 'All',
    },
    {
      id: FIXED_DUTY_STATE,
      name: FIXED_DUTY_STATE,
    },
  ];
}

export function getSubcsriptionTypes() {
  return [
    {
      id: 'PFE + Occupational',
      name: 'PFE + Occupational',
    },
    {
      id: 'PFE only',
      name: 'PFE only',
    },
  ];
}

export function getSizeShirtTypes() {
  return [
    {
      id: 'S',
      name: 'S',
    },
    {
      id: 'M',
      name: 'M',
    },
    {
      id: 'L',
      name: 'L',
    },
    {
      id: 'XL',
      name: 'XL',
    },
    {
      id: 'XXL',
      name: 'XXL',
    },
  ];
}

export function getRatingExam(rateShortname, rank) {
  if (rateShortname === 'PFE') {
    return `PFE ${rank}`;
  }
  return rateShortname.replace('X', getRatingExamNumber(rank));
}

export function getCycles(cycles) {
  let cyclesResponse = [];
  cycles.forEach((c) => {
    cyclesResponse.push(c);
  });
  return cyclesResponse;
}

export function validateEmail(email) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validatePassword(password) {
  if (!password || password.length < 12 || password.length > 30) {
    return false;
  }
  var re =
    /^(?=(.*[^A-Za-z0-9]){2,})(?=(.*[A-Z]){2,})(?=(.*\d){2,})(?=(.*[a-z]){2,}).+/;
  return re.test(String(password));
}

export function validateE(e) {
  const emailRex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(e.value)) {
    return true;
  } else {
    return false;
  }
}
